// Per-tab, in-memory-only trackers tied to a live upload process (TUS instance
// + poll interval) running in a single tab's JS heap. Persisting these to
// localStorage lets one tab's in-flight/completed upload leak into another
// tab as a frozen "ghost" entry (nothing there ever updates or removes it),
// causing duplicate/stuck progress cards and stale lists across tabs.
//
// IMPORTANT: reset to these defaults, never `delete` the keys. Redux Toolkit's
// `preloadedState` is used as-is for any slice key it already contains — it
// does NOT merge in the slice's own `initialState` for keys present in the
// preloaded object. Deleting a key here previously left it `undefined` (not
// `[]`) in every tab seeded from localStorage, which crashed any reducer that
// called `.push`/`.filter`/`.findIndex` on it (e.g. removeVideoUpload).
const TRANSIENT_COMMON_DEFAULTS: Record<string, any> = {
  videoUploads: [],
  addVideoListRefreshTrigger: 0,
  videoLoader: {},
};

export const saveToLocalStorage = (state: any) => {
  try {
    const stateToPersist = state?.common
      ? { ...state, common: { ...state.common } }
      : state;
    if (stateToPersist?.common) {
      Object.keys(TRANSIENT_COMMON_DEFAULTS).forEach((key) => {
        stateToPersist.common[key] = TRANSIENT_COMMON_DEFAULTS[key];
      });
    }
    const serializedState = JSON.stringify(stateToPersist);

    localStorage.setItem("state", serializedState);
  } catch (e) {
    //
  }
};

export const getPreloadedState = () => {
  try {
    const serializedState = localStorage.getItem("state");

    if (serializedState === null) return undefined;

    const parsedState = JSON.parse(serializedState);
    // Defensive: also reset on read, in case a blob written before this fix
    // (or by an older tab) still has these baked in with stale values.
    if (parsedState?.common) {
      Object.keys(TRANSIENT_COMMON_DEFAULTS).forEach((key) => {
        parsedState.common[key] = TRANSIENT_COMMON_DEFAULTS[key];
      });
    }
    return parsedState;
  } catch (e) {
    //

    return undefined;
  }
};

export const setSsBackRoute = (value: any) => {

  sessionStorage.setItem("backRoute", value && JSON.stringify(value));
};

export const getSsBackRoute = () => {
  let value: any = sessionStorage.getItem("backRoute");
  return value && JSON.parse(value);
};
export const removeSsBackRoute = () => sessionStorage.removeItem("backRoute");
